import { SingleRowAction } from '@galaxy/crm/static';
import { CampaignActionsService } from './campaign-actions.service';
import { NamespaceInterface } from './campaign-actions.interfaces';
import { MultiRowAction } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';

export function AddToCampaignSingleRowAction(
  namespace: NamespaceInterface,
  service: CampaignActionsService,
  label: string,
): SingleRowAction {
  return {
    label: label,
    callback: (row: Row) => {
      service.addToCampaign(namespace, [row]);
    },
  };
}

export function AddToCampaignMultiRowAction(
  namespace: NamespaceInterface,
  service: CampaignActionsService,
  label: string,
): MultiRowAction {
  return {
    label: label,
    callback: (rows: Row[]) => {
      service.addToCampaign(namespace, rows);
    },
  };
}
